/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Underline_TooltipInputs */

const en_style_guide_manager_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check for Events where all lines are underlined`)
};

const fr_style_guide_manager_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifier les evenements ou toutes les lignes sont soulignees`)
};

const de_style_guide_manager_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfen Sie, ob alle Zeilen unterstrichen sind.`)
};

const it_style_guide_manager_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla gli eventi in cui tutte le righe sono sottolineate`)
};

const ru_style_guide_manager_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверьте события, у которых все строки подчеркнуты.`)
};

const es_style_guide_manager_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprobar eventos en los que todas las líneas estén subrayadas`)
};

const zh_cn2_style_guide_manager_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查所有行都带有下划线的事件。`)
};

const ja_style_guide_manager_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての行に下線が引かれているイベントをチェックする`)
};

const hi_style_guide_manager_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उन घटनाओं की जाँच करें जहाँ सभी पंक्तियाँ रेखांकित हैं`)
};

const pt_pt2_style_guide_manager_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique os eventos em que todas as linhas estão sublinhadas.`)
};

/**
* | output |
* | --- |
* | "Check for Events where all lines are underlined" |
*
* @param {Style_Guide_Manager_Underline_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_underline_tooltip = /** @type {((inputs?: Style_Guide_Manager_Underline_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Underline_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_underline_tooltip(inputs)
	if (locale === "de") return de_style_guide_manager_underline_tooltip(inputs)
	if (locale === "it") return it_style_guide_manager_underline_tooltip(inputs)
	if (locale === "ru") return ru_style_guide_manager_underline_tooltip(inputs)
	if (locale === "es") return es_style_guide_manager_underline_tooltip(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_underline_tooltip(inputs)
	if (locale === "ja") return ja_style_guide_manager_underline_tooltip(inputs)
	if (locale === "hi") return hi_style_guide_manager_underline_tooltip(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_underline_tooltip(inputs)
	return en_style_guide_manager_underline_tooltip(inputs)
});